"use client"

import { format } from "date-fns"
import { ptBR } from "date-fns/locale"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table"

export interface GnreHistoryItem {
    id: number
    batch: string
    created_at: string
    generated_by: string | null
    nff: string
}

interface GnreHistoryModalProps {
    gnreHistory: GnreHistoryItem[]
}

export function GnreHistoryModal({ gnreHistory }: GnreHistoryModalProps) {
    if (!gnreHistory || gnreHistory.length === 0) {
        return (
            <div className="flex items-center justify-center py-12">
                <div className="text-center">
                    <div className="text-sm text-muted-foreground mb-1">Nenhum histórico encontrado</div>
                    <div className="text-xs text-muted-foreground">Esta nota fiscal não possui histórico de GNRE</div>
                </div>
            </div>
        )
    }

    return (
        <div className="space-y-4">
            <div className="text-sm font-medium">
                {gnreHistory.length} {gnreHistory.length === 1 ? "registro encontrado" : "registros encontrados"}
            </div>

            <div className="rounded-lg border bg-card">
                <div className="overflow-x-auto">
                    <Table>
                        <TableHeader>
                            <TableRow className="hover:bg-transparent">
                                <TableHead className="font-semibold text-xs uppercase tracking-wide">Lote</TableHead>
                                <TableHead className="font-semibold text-xs uppercase tracking-wide">Data</TableHead>
                                <TableHead className="font-semibold text-xs uppercase tracking-wide">Gerado por</TableHead>
                                <TableHead className="font-semibold text-xs uppercase tracking-wide">NFF</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {gnreHistory.map((gnre) => (
                                <TableRow key={gnre.id} className="hover:bg-muted/50">
                                    <TableCell>
                                        <code className="px-2 py-1 bg-muted rounded text-xs font-mono">{gnre.batch || "-"}</code>
                                    </TableCell>
                                    <TableCell className="text-sm">
                                        {gnre.created_at ? format(new Date(gnre.created_at), "dd/MM/yyyy HH:mm", { locale: ptBR }) : "-"}
                                    </TableCell>
                                    <TableCell className="text-sm">{gnre.generated_by || "Sistema"}</TableCell>
                                    <TableCell className="text-sm">{gnre.nff || "-"}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </div>
        </div>
    )
}
